var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { t } from '@mp/locale';
import interior from './interior.svg';
import interiorResidential from './interiorResidential.svg';
import interiorAndExterior from './interiorAndExterior.svg';
import interiorAndExteriorResidential from './interiorAndExteriorResidential.svg';
import { OrderContext } from '../../hooks/OrderContext';
import './CaptureRequirements.scss';
var DEFAULT_CHOICE = 'SPACE_TYPE_INDOOR_ONLY';
export default function CaptureRequirements(_a) {
    var _b, _c;
    var captureType = _a.captureType, handleTracking = _a.handleTracking, propertyType = _a.propertyType, setCaptureType = _a.setCaptureType;
    var _d = useState(DEFAULT_CHOICE), selection = _d[0], setSelection = _d[1];
    var order = useContext(OrderContext).order;
    var answerChoices = (_c = (_b = order === null || order === void 0 ? void 0 : order.available_questions) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.answer_choices;
    var isResidential = propertyType.toLowerCase() === 'residential';
    // // TODO: Removed this Mock answers
    // const answerChoices = [
    //   "SPACE_TYPE_INDOOR_ONLY",
    //   "SPACE_TYPE_INDOOR_OUTDOOR_ONLY"
    // ];
    var imageMap = {
        SPACE_TYPE_INDOOR_ONLY: isResidential ? interiorResidential : interior,
        SPACE_TYPE_INDOOR_OUTDOOR_ONLY: isResidential ? interiorAndExteriorResidential : interiorAndExterior,
    };
    var session = sessionStorage.getItem('order-details');
    useEffect(function () {
        var _a, _b, _c;
        var orderDetails = JSON.parse(session) || null;
        var sessionCaptureType = (_c = (_b = (_a = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.capture_requirements_questions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.answer_choices) === null || _c === void 0 ? void 0 : _c[0];
        if (sessionCaptureType) {
            setSelection(sessionCaptureType);
            setCaptureType(sessionCaptureType);
        }
    }, [session]);
    useEffect(function () {
        if (!answerChoices) {
            setSelection(DEFAULT_CHOICE);
            setCaptureType('');
        }
        if (answerChoices && !captureType) {
            setCaptureType(DEFAULT_CHOICE);
        }
    }, [answerChoices, captureType]);
    if (!answerChoices) {
        return null;
    }
    var handleChange = function (event) {
        var _a, _b;
        setSelection((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
        setCaptureType((_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value);
        handleTracking(event);
    };
    return (_jsxs("div", __assign({ className: "capture-services-capture-questions" }, { children: [_jsxs("p", __assign({ "data-qa": "property-details-title", className: "mp-capturesvc-step-subtitle" }, { children: [' ', t('CAPTURE_SERVICES.ORDER.PROPERTY_SIZE.subtitle-captured'), ' '] })), answerChoices.map(function (choice) {
                return choice === 'SPACE_TYPE_INDOOR_OUTDOOR_SURROUNDING' ? null : (_jsxs("label", { children: [_jsx("input", { type: "radio", name: "capture_location", checked: choice === selection, value: choice, onChange: handleChange }), _jsxs("div", __assign({ className: "capture-services-capture-choice" }, { children: [_jsx("span", __assign({ className: "capture-services-capture-radio" }, { children: _jsx("span", {}) })), _jsx("img", { src: imageMap[choice] }), _jsxs("div", __assign({ className: "capture-services-capture-question-text" }, { children: [_jsx("h3", { children: t("CAPTURE_SERVICES.SCHEDULER.CAPTURE_QUESTIONS.".concat(choice, ".label")) }), _jsx("p", { children: t("CAPTURE_SERVICES.SCHEDULER.CAPTURE_QUESTIONS.".concat(choice, ".description")) })] }))] }))] }, choice));
            })] })));
}
